import ViewsQuiz from '@/views/quiz/ViewsQuiz.vue';
import {PERMISSIONS} from '@/constants';
import {RouteRecordRaw} from 'vue-router';

export default [
    {
        path: '/quiz/:page?',
        name: 'quiz',
        component: ViewsQuiz,
        meta: {
            requiresAuth: true
        }
    }
] as RouteRecordRaw[]
